import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { Route, Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import * as reportsActions from '../../actions/Reports';
import LocaleComponent from '../../LocaleComponent';

class Breadcrumbs extends LocaleComponent {

  render() {
    const { location, customers } = this.props;
    const pathname = location.pathname;
    const mcId = this.getMcId();

    const arr = customers.filter(customer => {
      return customer.MCID.toString() === mcId;
    });

    const customer = arr.length ? arr[0] : null;

    const mcidActive = (pathname === '/' || pathname === '/dashboard' || pathname === '/report');

    const linkList = [
      { path: `/settings`,
        name: customer ?
          `MCID ${customer.MCID} ${customer.campaign_name}` :
          this.localeMessage('Settings')
      } ,
      { path: `/campaigns`, name: this.localeMessage('Campaign') },
      { path: `/adgroups`, name: this.localeMessage('AdGroup') },
      { path: `/ads`, name: this.localeMessage('Ad') },
      { path: `/keywords`, name: this.localeMessage('Keywords') },
      { path: `/extensions`, name: this.localeMessage('Extensions') },
      { path: `/placements`, name: this.localeMessage('Placements') },
      { path: `/pages`, name: this.localeMessage('Pages') },
    ];

    linkList.forEach(link => {
      link.active = pathname.startsWith(link.path);
    });

    return (
      <Breadcrumb>
        {mcidActive ?
            <BreadcrumbItem active>
              <strong>
                {this.localeMessage('MCID')}
              </strong>
            </BreadcrumbItem>
          :
            <div>
              {linkList.map(link =>
                  <BreadcrumbItem active key={link.name}>
                    <Link to={`${link.path}?mcId=${mcId}`}>
                      {link.active ?
                          <strong>{link.name}</strong> :
                          <font style={{color: 'black'}}>{link.name}</font>}
                    </Link>
                  </BreadcrumbItem>)}
            </div>
        }
      </Breadcrumb>
    );
  }
}

class BreadcrumbsContainer extends Component {
  static propTypes = {
    customers: PropTypes.array,
    selectedCampaign: PropTypes.object,
    dispatch: PropTypes.func.isRequired
  };

  render() {
    return <Breadcrumbs
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

BreadcrumbsContainer = connect(state => ({
  mcId: state.reports.get('mcId'),
  customers: state.reports.get('customers'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(BreadcrumbsContainer);

export default props => (
  <div>
    <Route path="/:path" component={BreadcrumbsContainer} {...props} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js